<template lang="pug">
  .modal.is-active
    .modal-background
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column.is-offset-2.is-8
            .field
              label.label {{ config.question }}
                .control
                  input.input.is-dark(
                    type='text', 
                    placeholder='',
                    v-model="valor"
                  )
        .columns(v-show="mensajeVacio")
          .column.is-offset-2
            span.tag.is-danger
              | Debe introducir un motivo para la actualización.
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-black.is-rounded(@click="aceptar" :disabled='disabled')
                    | {{ config.textOk }}
</template>

<script>
  export default {
    name: 'ModalUpdate',
    props: {
      config: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        valor: '',
        disabled: true,
        mensajeVacio: false,
      }
    },
    watch: {
      valor() {
        const motivo = this.valor.trim()
        if (motivo.length > 0) {
          this.disabled = false
          this.mensajeVacio = false
        } else {
          this.disabled = true
        }
      }
    },
    methods: {
      aceptar () {
        if (this.disabled) {
          return
        }
        if (this.valor === '') {
          this.mensajeVacio = true
          return
        }
        const obj = {
          save: true,
          valor: this.valor
        }
        this.valor = ''
        this.$emit('closeModalUpd', obj)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/ModalUpdate.vue